import { SystemIntelligenceView } from '@/components/systems/SystemIntelligenceView'
import { auroraPage } from '@/lib/aurora-data'

/** Aurora's drill-down — the sales-side view of a system the Overview shows as a tile. */
export function AuroraSalesIntelligence() {
  return <SystemIntelligenceView {...auroraPage} />
}
